import React from 'react';
import Input from '../elements/Input';

const FinancialInformationForm = ({ formData, setFormData, formError }) => (
  <>
    <Input
      label="Account Type"
      value={formData.accountType || ''}
      onChange={e => setFormData({ ...formData, accountType: e.target.value })}
      placeholder="e.g. Savings, Fixed Deposit, Mutual Fund"
      error={formError.accountType}
    />
    <Input
      label="Institution Name"
      value={formData.institution || ''}
      onChange={e => setFormData({ ...formData, institution: e.target.value })}
      placeholder="e.g. HDFC Bank, SBI, ICICI Prudential"
      error={formError.institution}
    />
    <Input
      label="Account Number"
      value={formData.accountNumber || ''}
      onChange={e => setFormData({ ...formData, accountNumber: e.target.value })}
      placeholder="e.g. 1234567890"
      error={formError.accountNumber}
    />
    <Input
      label="Notes / Details"
      type="textarea"
      value={formData.notes || ''}
      onChange={e => setFormData({ ...formData, notes: e.target.value })}
      placeholder="e.g. Joint account with spouse, nominee: Anjali, matures 2027-12-31"
      error={formError.notes}
    />
  </>
);

export default FinancialInformationForm;